import React from "react";
import { Position } from "reactflow";
import { faCalendar, faCartShopping, faCircleDot, faCircleNodes, faClone, faCloudArrowUp, faCode, faCodeMerge, faCopy, faDatabase, faDesktop, faDiagramProject, faDownload, faEarthAmericas, faEnvelope, faFileLines, faFilter, faFolderTree, faLaptop, faMicrophone, faPencil, faPlay, faRobot, faRoute, faRss, faSearch, faServer, faTags, faUpload, faUsers, faVolumeHigh, faWandMagicSparkles, faFileWord } from "@fortawesome/free-solid-svg-icons";
import { faConnectdevelop, faFacebook, faFacebookMessenger, faGoogle, faGoogleDrive, faInstagram, faJira, faMeta, faNotion, faShopify, faSlack, faTrello, faWhatsapp, faWordpress } from "@fortawesome/free-brands-svg-icons";
import { faClock, faFile, faFolderOpen } from "@fortawesome/free-regular-svg-icons";
import { Sidebar } from '../../components/sidebar';
import { View } from '../../components/view';
import { operationType } from '../../services/types';
import { Main } from "./style";
import { handleFileUploaderRun } from "../../components/nodes/children/knowledge/upload/files";
import { handleDocSearchRun } from "../../components/nodes/children/knowledge/upload/docSearch";

export function Workflow() {
   // Auth bootstrap (auth_token query → cookie → Redux) lives in App.tsx so we
   // never need window.location.reload() inside the console iframe.
   React.useEffect(() => {
      document.title = 'Dragify AI - Workflow';
   }, []);

   return (<Main><Sidebar /><View /></Main>);
}

// ---
export const workflowItems: operationType[] = [
   /* ===================== FETCH DATA ===================== */
   {
      icon: faWhatsapp,
      background: "#323432ff",
      name: "WhatsApp Listener",
      action: "whatsappListener",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faWhatsapp,
      background: "#323432ff",
      name: "WhatsApp Cloud Trigger",
      action: "whatsappCloudTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faMeta,
      background: "#323432ff",
      name: "Meta Listener",
      action: "metaListenerTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faDatabase,
      background: "#323432ff",
      name: "SQL Trigger",
      action: "sqlTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faGoogleDrive,
      background: "#323432ff",
      name: "Drive Trigger",
      action: "googleDriveTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faSlack,
      background: '#323432ff',
      name: 'Slack Trigger',
      action: 'slackTrigger',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Triggers' },
      outputType: 'text',
      postions: [
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faUsers,
      background: '#323432ff',
      name: 'Teams Trigger',
      action: 'teamsTrigger',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Triggers' },
      outputType: 'text',
      postions: [
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faFolderTree, background: '#323432', name: 'SharePoint Trigger', action: 'sharepointTrigger',
      category: ['Fetch Data'], subCategory: { 'Fetch Data': 'Triggers' }, outputType: 'text',
      postions: [{ type: 'source', label: '', dir: Position.Right }]
   },
   {
      icon: faCalendar,
      background: "#323432ff",
      name: "Calendar Trigger",
      action: "googleCalendarTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faCloudArrowUp, background: '#323432ff', name: 'OneDrive Trigger', action: 'oneDriveTrigger',
      category: ['Fetch Data'], subCategory: { 'Fetch Data': 'Triggers' }, outputType: 'text',
      postions: [{ type: 'source', label: '', dir: Position.Right }]
   },
   {
      icon: faCloudArrowUp, background: '#0078D4', name: 'Microsoft OneDrive', action: 'oneDrive',
      category: ['Fetch Data', 'Actions'], subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' },
      outputType: 'text', outputTypeSub: 'fileURL', postions: [{ type: 'target', label: '', dir: Position.Left }, { type: 'source', label: '', dir: Position.Right }]
   },
   {
      icon: faFileLines,
      background: "#323432ff",
      name: "Typeform Trigger",
      action: "typeformTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faFileLines,
      background: "#323432ff",
      name: "Google Form Trigger",
      action: "googleFormTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: 'images/outlook.svg',
      background: '#323432ff',
      name: 'Outlook Trigger',
      action: 'outlookTrigger',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Triggers' },
      outputType: 'text',
      postions: [{ type: 'source', label: '', dir: Position.Right }],
   },
  {
      icon: faShopify,
      background: "#323432ff",
      name: "Shopify Trigger",
      action: "shopifyTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faCircleDot,
      background: "#323432ff",
      name: "Odoo Trigger",
      action: "odooTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faCartShopping,
      background: "#323432ff",
      name: "Easy Orders Trigger",
      action: "easyOrdersTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faCartShopping,
      background: "#323432ff",
      name: "Bosta Trigger",
      action: "bostaTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: 'images/woocommerce.png',
      background: "#323432ff",
      name: "WooCommerce Trigger",
      action: "woocommerceTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faEnvelope,
      background: "#323432ff",
      name: "IMAP Email",
      action: "imapTrigger",
      category: ["Fetch Data"],
      subCategory: { 'Fetch Data': "Triggers" },
      outputType: "text",
      postions: [{ type: "source", label: "", dir: Position.Right }],
   },
   {
      icon: faFolderTree, 
      background: 'rgb(234, 179, 8)',
      name: 'RAG/Multi Rag', 
      action: 'docSearch', 
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Knowledge & Search' }, 
      outputType: 'text', 
      executeRun: handleDocSearchRun, 
      postions: [
         { type: 'target', label: 'Input', dir: Position.Left },
         { type: 'target', label: 'File', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   }, 
   { 
      icon: faFolderOpen, 
      background: 'rgb(107, 114, 128)',
      name: 'Knowledge-Bases', 
      action: 'knowledge',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Knowledge & Search'}, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right },
      ]
   },
   {
      icon: faEarthAmericas, 
      background: 'rgb(168, 85, 247)',
      name: 'URL + Search', 
      action: 'urlSearch', 
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Knowledge & Search' }, 
      outputType: 'text', 
      postions: [
         { type: 'target', label: 'Input', dir: Position.Left }, 
         { type: 'target', label: 'Website-URL', dir: Position.Left }, 
         { type: 'target', label: 'File', dir: Position.Left }, 
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faRss,
      background: "#F89D3E",
      name: "RSS",
      action: "rss",
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Knowledge & Search' }, 
      outputType: "text",
      postions: [
         { type: "source", label: "", dir: Position.Right },
      ],
   },
   {
      icon: faSearch,
      background: '#2eb907ff',
      name: 'Web Search',
      action: 'webSearch',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Knowledge & Search' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right },
      ],
   },
   {
      icon: faDesktop,
      background: '#0ea5e9',
      name: 'Browser Use',
      action: 'browserUse',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Knowledge & Search' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right },
      ],
   },
   {
      icon: faLaptop,
      background: '#6366f1',
      name: 'Computer Use',
      action: 'computerUse',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Knowledge & Search' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right },
      ],
   },
   { 
      icon: faFile, 
      background: '#22c55e',
      name: 'Spreadsheet',
      action: 'spreadsheet',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Knowledge & Search' }, 
      outputType: 'text', 
      postions: [
         { type: 'target', label: 'Input', dir: Position.Left },
         { type: 'target', label: 'Spreadsheet-Id', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faGoogleDrive, 
      background: '#22c55e',
      name: 'Google Drive', 
      action: 'googleDrive', // here
      category: ['Fetch Data'], 
      subCategory: { 'Fetch Data': 'Files & Storage' }, 
      outputType: 'text',
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left }, 
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: 'images/azure.svg', 
      background: 'rgb(59, 130, 246)',
      name: 'Azure Storage', 
      action: 'azureStorage', 
      category: ['Fetch Data'], 
      subCategory: { 'Fetch Data': 'Files & Storage' }, 
      outputType: 'text',
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left }, 
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faCloudArrowUp,
      background: '#06b6d4',
      name: 'File Uploader', 
      action: 'fileUploader', 
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Files & Storage' }, 
      outputType: 'text',
      outputTypeSub: 'fileURL', 
      executeRun: handleFileUploaderRun, 
      postions: [{ type: 'target', label: '', dir: Position.Left }, { type: 'source', label: '', dir: Position.Right }]
   },
   { 
      icon: faDatabase, 
      background: '#0a6fa0',
      name: 'SQL', 
      action: 'sql', 
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Databases' }, 
      outputType: 'text', 
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right },
      ]
   },
   { 
      icon: faSearch, 
      background: '#498BFC',
      name: 'Big Query', 
      action: 'bigQuery', 
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Databases' }, 
      outputType: 'text', 
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right },
      ]
   },
   { 
      icon: faServer, 
      background: '#06b6d4',
      name: 'Query Database', 
      action: 'queryDatabase', 
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Databases' }, 
      outputType: 'text', 
      postions: [
         { type: 'target', label: '', dir: Position.Left }, 
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: 'images/airtable.png',
      background: '#000000ff',
      name: 'Airtable',
      action: 'airtable',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Databases'},
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: 'images/supabase.png',
      background: '#000000ff',
      name: 'Supabase',
      action: 'supabase',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Databases' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faDatabase,
      background: '#7c3aed',
      name: 'Dragify Table',
      action: 'dataTable',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Databases' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faEnvelope,
      background: 'rgb(239, 68, 68)',
      name: 'Gmail', 
      action: 'gmail', 
      category: ['Fetch Data', 'Actions'],
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' }, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: 'images/outlook.svg',
      background: 'rgb(59, 130, 246)',
      name: 'Outlook', 
      action: 'outlook', 
      category: ['Fetch Data', 'Actions'],
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' }, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faFacebook,
      background: 'rgb(59, 130, 246)',
      name: 'Facebook Posting', 
      action: 'facebookPosting', 
      category: ['Fetch Data', 'Actions'],
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' }, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faInstagram,
      background: "#D62976",
      name: "Instagram Posting",
      action: "instagramPosting",
      category: ["Fetch Data", "Actions"],
      subCategory: {
         "Fetch Data": "Apps & Services",
         Actions: "Apps & Services",
      },
      outputType: "text",
      outputTypeSub: "fileURL",
      postions: [
         { type: "target", label: "", dir: Position.Left },
         { type: "source", label: "", dir: Position.Right },
      ],
   },
   {
      icon: faShopify,
      background: '#95BF47',
      name: 'Shopify',
      action: 'shopify',
      category: ['Fetch Data', 'Actions'],
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' },
      outputType: 'text',
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faCartShopping,
      background: '#0f766e',
      name: 'Easy Orders',
      action: 'easyOrders',
      category: ['Fetch Data', 'Actions'],
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' },
      outputType: 'text',
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faCartShopping,
      background: '#ff5a1f',
      name: 'Bosta',
      action: 'bosta',
      category: ['Fetch Data', 'Actions'],
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' },
      outputType: 'text',
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: 'images/woocommerce.png',
      background: '#96588A',
      name: 'WooCommerce',
      action: 'woocommerce',
      category: ['Fetch Data', 'Actions'],
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' },
      outputType: 'text',
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: 'images/clickup.svg', 
      background: '#FF4CA0',
      name: 'ClickUp', 
      action: 'clickup',
      category: ['Fetch Data', 'Actions'], 
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' }, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: 'Full-Output', dir: Position.Right },
         { type: 'source', label: 'Output-Lists', dir: Position.Right },
         { type: 'source', label: 'Output-Tasks', dir: Position.Right },
         { type: 'source', label: 'Output-Task-Link', dir: Position.Right },
      ]
   },
   { 
      icon: faJira, 
      background: '#0A61F1',
      name: 'Jira', 
      action: 'jira', 
      category: ['Fetch Data', 'Actions'], 
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' }, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faTrello, 
      background: '#2D88FF',
      name: 'Trello', 
      action: 'trello', 
      category: ['Fetch Data', 'Actions'], 
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' }, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left }, 
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faSlack, 
      background: '#963498',
      name: 'Slack', 
      action: 'slack', 
      category: ['Fetch Data', 'Actions'], 
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' }, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left }, 
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faUsers,
      background: '#6264A7',
      name: 'Microsoft Teams',
      action: 'teams',
      category: ['Fetch Data', 'Actions'],
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' },
      outputType: 'text',
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faFolderTree, background: '#038387', name: 'Microsoft SharePoint', action: 'sharepoint',
      category: ['Fetch Data', 'Actions'], subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' },
      outputType: 'text', outputTypeSub: 'fileURL', postions: [{ type: 'target', label: '', dir: Position.Left }, { type: 'source', label: '', dir: Position.Right }]
   },
   { 
      icon: faWordpress, 
      background: '#08789D',
      name: 'WordPress', 
      action: 'wordPress',
      category: ['Fetch Data'],
      subCategory: { 'Fetch Data': 'Apps & Services', 'Actions': 'Apps & Services' }, 
      outputType: 'text', 
      postions: [
         { type: 'target', label: '', dir: Position.Left }, 
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   /* ===================== PROCESS ===================== */
   { 
      isMediator: true, 
      icon: faDownload, 
      background: '#009999',
      name: 'Input', 
      action: 'input', 
      category: ['Process'],
      subCategory: { 'Process': 'I/O functions' }, 
      postions: [{ type: 'source', dir: Position.Right }]
   },
   { 
      isMediator: true, 
      icon: faUpload, 
      background: '#06b6d4',
      name: 'Output', 
      action: 'output', 
      category: ['Process'],
      subCategory: { 'Process': 'I/O functions' }, 
      postions: [{ type: 'target', dir: Position.Left }]
   },
   { 
      icon: faCircleNodes, 
      background: '#669999',
      name: 'Webhook', 
      action: 'webhook', 
      category: ['Process'],
      subCategory: { 'Process': 'I/O functions' }, 
      outputType: 'text', 
      postions: [
         { type: 'source', label: 'Full-Output', dir: Position.Right }
      ]
   },
   {
      icon: faPlay,
      background: '#009999',
      name: 'Start',
      action: 'start',
      category: ['Process'],
      subCategory: { 'Process': 'Flow Control' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right },
      ],
   },
   { 
      icon: faClone, 
      background: 'rgb(107, 114, 128)',
      name: 'Sub-Workflow', 
      action: 'subWorkflow', 
      category: ['Process'],
      subCategory: { 'Process': 'Flow Control' }, 
      outputType: 'text', 
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faRoute, 
      background: '#B453E6',
      name: 'Routing', 
      action: 'routing', 
      category: ['Process'],
      subCategory: { 'Process': 'Flow Control' }, 
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left }, 
         { type: 'source', label: 'Output-True', dir: Position.Right }, 
         { type: 'source', label: 'Output-False', dir: Position.Right },
      ]
   },
   {
      icon: faTags,
      background: '#0f766e',
      name: 'Jev Classifier',
      action: 'jevClassifier',
      category: ['Process'],
      subCategory: { 'Process': 'I/O functions' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: 'Class', dir: Position.Right },
         { type: 'source', label: 'Low confidence', dir: Position.Bottom },
      ]
   },
   {
      icon: faClock,
      background: "#54B8C9",
      name: "Wait",
      action: "wait",
      category: ['Process'],
      subCategory: { 'Process': 'Flow Control' }, 
      outputType: 'text',
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: "source", label: '', dir: Position.Right },
      ],
   },
   {
      icon: faCodeMerge,
      background: "#54B8C9",
      name: "Merge",
      action: "merge",
      category: ['Process'],
      subCategory: { 'Process': 'Flow Control' }, 
      outputType: "text",
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: "source", label: '', dir: Position.Right },
      ],
   },
   {
      icon: faFilter,
      background: "#54B8C9",
      name: "Filter",
      action: "filter",
      category: ['Process'],
      subCategory: { 'Process': 'Flow Control' }, 
      outputType: "text",
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: "source", label: '', dir: Position.Right },
      ],
   },
   { 
      icon: faRobot, 
      background: '#06b6d4',
      name: 'AI Agent', 
      action: 'aiAgent', 
      category: ['Process'],
      subCategory: { 'Process': 'AI & Reasoning' }, 
      outputType: 'text', 
      postions: [
         { type: 'target', label: 'Input', dir: Position.Left },
         { type: 'source', label: 'Output', dir: Position.Right },
         { type: 'source', label: 'Tools', dir: Position.Right },
      ]
   },
   {
      icon: 'images/openai.svg',
      background: '#17A683',
      name: 'OpenAI',
      action: 'openai',
      category: ['Process'],
      subCategory: { 'Process': 'AI & Reasoning' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: 'images/deepseek.svg',
      background: '#4D6BFE',
      name: 'Deepseek',
      action: 'deepseek',
      category: ['Process'],
      subCategory: { 'Process': 'AI & Reasoning' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: 'images/qwen.svg',
      background: '#6F69F7',
      name: 'Qwen',
      action: 'qwen',
      category: ['Process'],
      subCategory: { 'Process': 'AI & Reasoning' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faWandMagicSparkles,
      background: '#10A37F',
      name: 'Dragify AI',
      action: 'dragifyAI',
      category: ['Process'],
      subCategory: { 'Process': 'AI & Reasoning' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faGoogle, 
      background: '#5393FD',
      name: 'Gemini', 
      action: 'googleGemini',
      category: ['Process'], 
      subCategory: { 'Process': 'AI & Reasoning' },  
      outputType: 'text', 
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faMeta, 
      background: '#0182F0',
      name: 'Llama', 
      action: 'llama',
      category: ['Process'], 
      subCategory: { 'Process': 'AI & Reasoning' },  
      outputType: 'text', 
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faCopy, 
      background: '#E52429',
      name: 'PDF Chunker', 
      action: 'pdfChunker', 
      category: ['Process'],
      subCategory: { 'Process': 'Data Processing' }, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left }, 
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faDiagramProject, 
      background: '#ff66cc',
      name: 'Flow Queue', 
      action: 'flowQueue',
      category: ['Process'],
      subCategory: { 'Process': 'Data Processing' }, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left }, 
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faPencil,
      background: "#898FFF",
      name: "Edit Fields",
      action: "editFields",
      category: ['Process'],
      subCategory: { 'Process': 'Data Processing' }, 
      outputType: "text",
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: "source", label: "", dir: Position.Right },
      ],
   },
   { 
      icon: faConnectdevelop, 
      background: '#336699',
      name: 'Custom API', 
      action: 'customAPI', 
      category: ['Process'],
      subCategory: { 'Process': 'Data Processing' }, 
      outputType: 'text', 
      postions: [
         { type: 'target', label: '', dir: Position.Left},
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faCode, 
      background: '#FF9922',
      name: 'Code', 
      action: 'code', 
      category: ['Process'],
      subCategory: { 'Process': 'Data Processing' }, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right },
      ]
   },
   // { 
   //    icon: faVideo, 
   //    background: '#4D88FF',
   //    name: 'Video Vision', 
   //    action: 'videoVision', 
   //    category: ['Process'],
   //    subCategory: { 'Process': 'Media Processing' },
   //    outputType: 'text', 
   //    postions: [
   //       { type: 'target', label: '', dir: Position.Left }, 
   //       { type: 'source', label: '', dir: Position.Right }
   //    ]
   // },
   { 
      icon: faFileLines, 
      background: '#06b6d4',
      name: 'OCR', 
      action: 'ocr', 
      category: ['Process'],
      subCategory: { 'Process': 'Media Processing' }, 
      outputType: 'text', 
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left }, 
         { type: 'source', label: 'Output-Full', dir: Position.Right },
         { type: 'source', label: 'Output-Processed-Files', dir: Position.Right }
      ]
   },
   {
      icon: faMicrophone,
      background: '#4CAF50',
      name: 'Speech to Text',
      action: 'speechToText',
      category: ['Process'],
      subCategory: { 'Process': 'Media Processing' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faVolumeHigh,
      background: '#FF6B35',
      name: 'Text to Speech',
      action: 'textToSpeech',
      category: ['Process'],
      subCategory: { 'Process': 'Media Processing' },
      outputType: 'text',
      outputTypeSub: 'fileURL',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faFileWord,
      background: '#0ea5e9',
      name: 'Document Intelligence',
      action: 'documentIntelligence',
      category: ['Process'],
      subCategory: { 'Process': 'AI / Productivity' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: faWandMagicSparkles,
      background: '#7c3aed',
      name: 'Media Intelligence',
      action: 'mediaIntelligence',
      category: ['Process'],
      subCategory: { 'Process': 'Media Processing' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   /* ===================== ACTIONS ===================== */
   {
      icon: faWhatsapp,
      background: "#25D366",
      name: "WhatsApp Sender",
      action: "whatsappSendMessage",
      category: ['Actions'], 
      subCategory: { 'Actions': 'Messaging' },
      outputType: "text",
      postions: [
         { type: "target", label: "", dir: Position.Left },
         { type: "source", label: "", dir: Position.Right },
      ],
   },
   {
      icon: faWhatsapp,
      background: "#25D366",
      name: "WhatsApp Cloud Sender",
      action: "whatsappCloudSendMessage",
      category: ['Actions'], 
      subCategory: { 'Actions': 'Messaging' },
      outputType: "text",
      postions: [
         { type: "target", label: "", dir: Position.Left },
         { type: "source", label: "", dir: Position.Right },
      ],
   },
   {
      icon: faFacebookMessenger,
      background: "#08AAFF",
      name: "Messenger Sender",
      action: "messengerSendMessage",
      category: ['Actions'], 
      subCategory: { 'Actions': 'Messaging' },
      outputType: "text",
      postions: [
         { type: "target", label: "", dir: Position.Left },
         { type: "source", label: "", dir: Position.Right },
      ],
   },
   {
      icon: faInstagram,
      background: "#D62976",
      name: "Instagram Sender",
      action: "instaSendMessage",
      category: ['Actions'], 
      subCategory: { 'Actions': 'Messaging' }, 
      outputType: "text",
      postions: [
         { type: "target", label: "", dir: Position.Left },
         { type: "source", label: "", dir: Position.Right },
      ],  
   },
   {
      icon: 'images/Twilio.png',
      background: "#CF272D",
      name: "Twilio SMS",
      action: "twilioSendSms",
      category: ['Actions'],
      subCategory: { 'Actions': 'Messaging' },
      outputType: "text",
      postions: [
         { type: "target", label: "", dir: Position.Left },
         { type: "source", label: "", dir: Position.Right },
      ],
   },
   {
      icon: faCalendar,
      background: "#4D8FFA",
      name: "Google Calendar",
      action: "googleCalendar",
      category: ['Actions'], 
      subCategory: { 'Actions': 'Apps & Services' }, 
      outputType: "text",
      postions: [
         { type: "target", label: "", dir: Position.Left },
         { type: "source", label: "", dir: Position.Right },
      ],
   },
   { 
      icon: faCircleDot, 
      background: '#A54C8D',
      name: 'Odoo', 
      action: 'odoo',
      category: ['Fetch Data', 'Actions'],
      subCategory: { 'Fetch Data': 'CRMs & ERPs', 'Actions': 'CRMs & ERPs' }, 
      outputType: 'text', 
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   {
      icon: 'images/erpnext.png',
      background: '#0089FF',
      name: 'ERPNext',
      action: 'erpnext',
      category: ['Fetch Data', 'Actions'],
      subCategory: { 'Fetch Data': 'CRMs & ERPs', 'Actions': 'CRMs & ERPs' },
      outputType: 'text',
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   },
   { 
      icon: faNotion, 
      background: '#080808',
      name: 'Notion', 
      action: 'notion',
      category: ['Fetch Data', 'Actions'],
      subCategory: { 'Fetch Data': 'CRMs & ERPs', 'Actions': 'CRMs & ERPs' }, 
      outputType: 'text', 
      postions: [
         { type: 'target', label: '', dir: Position.Left },
         { type: 'source', label: '', dir: Position.Right }
      ]
   }
   // { 
   //    icon: faComments, 
   //    background: '#cccc00',
   //    name: 'Chatbot Scenario', 
   //    action: 'sequencer', 
   //    category: ['Process'],
   //    subCategory: { 'Process': 'Agents' }, 
   //    outputType: 'text', 
   //    postions: [
   //       { type: 'target', label: '', dir: Position.Left },
            // output: ['Output-Message', 'Output-Full', 'Output-Summary']
   //       { type: 'source', label: '', dir: Position.Right },
   //    ]
   // },
   // { 
   //    icon: faCodeMerge, 
   //    background: '#06b6d4',
   //    name: 'Actions Agent', 
   //    action: 'actionsAgent', 
   //    category: ['Process'],
   //    subCategory: { 'Process': 'Agents' }, 
   //    outputType: 'text', 
   //    postions: [
   //       { type: 'target', label: 'Data', dir: Position.Left },
   //       { type: 'source', label: 'Output', dir: Position.Bottom },
   //    ]
   // },
   // { 
   //    icon: faRocketchat, 
   //    background: '#06b6d4',
   //    name: 'Conversation Agent', 
   //    action: 'chatAgent', 
   //    category: ['Process'],
   //    subCategory: { 'Process': 'Agents' }, 
   //    outputType: 'text', 
   //    postions: [
   //       { type: 'target', label: 'Knowledge-Bases', dir: Position.Left },
   //       { type: 'target', label: 'ChatId', dir: Position.Left },
   //       { type: 'target', label: 'Message', dir: Position.Left },
   //       { type: 'source', label: 'Output', dir: Position.Right },
   //       { type: 'source', label: 'Output-Message', dir: Position.Right }
   //    ]
   // },
];

